import Axios from "../config/axios-v1-config";

// Flotas tercerizadas: la mitad ORGANIZATIVA (qué repartidores componen la flota de
// cada líder). Vive en microservice-users, que es el dueño del dato de usuario; el
// MONTO que se le paga al líder viaja aparte, en la config versionada de pago a
// repartidores (`/billing/driver-payment-config`). Son dos servicios distintos a
// propósito, así que también son dos guardados distintos: no hay commit en dos fases.
//
// El operador y el rol los resuelve el backend desde el token; acá no viaja ningún
// identificador de empresa.

/** Repartidores del operador con su flota vigente (líder + desde cuándo). */
export const getDriverFleets = () => Axios.get("users/driver-fleets");

/**
 * Deja la flota del líder EXACTAMENTE con `memberIds` (declarativo: el backend deriva
 * altas y bajas). `from` es el instante ISO desde el que rige el cambio; la pantalla
 * manda la medianoche local del día elegido para que ningún día quede partido entre el
 * repartidor y su líder.
 */
export const saveFleetMembers = (leaderId, { memberIds, from }) =>
  Axios.put(`users/driver-fleets/${leaderId}/members`, { memberIds, from });
